export class ViewportSize {
  constructor(width, height) {
    this.width = width
    this.height = height
  }
}



// WEBPACK FOOTER //
// ./src/api/model/StatisticsData/ViewportSize.js